import { hasAttr } from "@util/Obj";
import { Fragment } from "react";

const presetTickets = {
  "terminate-account" : {
    title: "We're sad you left 😢",
    slug: "The reason we started Mosanic was because of user like you.",
    intro: (
      <Fragment>
        We value your opinion very much and would massively appreciate it if you would like to tell us why. <br/> 
        So we can keep improving and maybe get you back in the future.
      </Fragment>
    ),
    help: "Note that it will take up-to 31 days to fully remove all of your data. In this time you will also be able to contact us to check if a revert is possible.",
    ticketHeader: 'Leave a message.',
    subject: "Reason",
    type: 'termination',
  },
  "default" : {
    title: "Ticket 🎟️",
    intro: (
      <Fragment>
        Hi There, tell us what going on! <br/> 
        We&apos;re here to help.
      </Fragment>
    ),
    ticketHeader: 'Submit a ticket.',
    ticketIntro: (
      <Fragment>
        Once submitted one of our team members will pick up on the ticket. <br/>
        
      </Fragment>
    ),
    subject: "Subject",
    type: 'unknown',
  },
  "dashboard" : {
    ticketHeader: 'Send a ticket 🎟️',
    ticketIntro: (
      <Fragment>
        Once submitted one of our team members will pick up on the ticket. <br/>
        We value your opinion and are here to help!
      </Fragment>
    ),
    subject: "Subject",
    type: 'unknown',
  }
}
export const getTicketData = (type) => {
    if(!hasAttr(presetTickets, type)) type = 'default';
    return presetTickets[type];
}